import { render, staticRenderFns } from "./bbsCardItem.vue?vue&type=template&id=588cafd4&scoped=true"
import script from "./bbsCardItem.vue?vue&type=script&lang=ts"
export * from "./bbsCardItem.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./bbsCardItem.vue?vue&type=style&index=0&id=588cafd4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "588cafd4",
  "5f31f74b"
  
)

export default component.exports